/**
 * Writes rows to an .xlsx workbook and hands it to the browser as a download.
 *
 * exceljs is loaded on demand: it is a few hundred kilobytes and only the admin
 * exports need it, so the main bundle does not carry it for every customer
 * user who never presses the button.
 */
export async function downloadWorkbook({ fileName, sheetName, columns, rows }) {
  const loaded = await import("exceljs");
  const ExcelJS = loaded.default || loaded;

  const workbook = new ExcelJS.Workbook();
  workbook.created = new Date();

  const sheet = workbook.addWorksheet(sheetName, {
    views: [{ state: "frozen", ySplit: 1 }],
  });

  sheet.columns = columns.map((column) => ({
    header: column.header,
    key: column.header,
    width: column.width,
  }));
  sheet.getRow(1).font = { bold: true };
  sheet.autoFilter = {
    from: { row: 1, column: 1 },
    to: { row: 1, column: columns.length },
  };

  rows.forEach((row) => sheet.addRow(row));

  const buffer = await workbook.xlsx.writeBuffer();
  saveBlob(
    new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    fileName
  );
}

/** Triggers a browser download of `blob` under `fileName`. */
export function saveBlob(blob, fileName) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
